import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import CourseFormatCard from 'src/components/PostGraduationContent/PostgraduateComponents/CourseFormatCard/CourseFormatCard'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './Information.styles'

const Information = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const courseFormat = [
    {
      title: t('news.postgraduate.info.c1'),
      lines: ['368 h/a', '(23 créditos)']
    },
    {
      title: t('news.postgraduate.info.c2'),
      lines: ['96 h/a', '(6 créditos)']
    },
    {
      title: t('news.postgraduate.info.c3'),
      lines: ['32 h/a', '(2 créditos)']
    },
    {
      title: t('news.postgraduate.info.c4'),
      lines: ['Residência', 'Prática']
    },
    {
      title: t('news.postgraduate.info.total'),
      lines: ['496 h/a', '(31 créditos)']
    },
    {
      title: t('news.postgraduate.info.options'),
      lines: ['Segundas a sextas', 'manhã e tarde']
    },
    {
      title: t('news.postgraduate.info.spots'),
      lines: ['12 vagas ampla concorrência', '2 vagas servidores UFC']
    }
  ]

  return (
    <>
      <Typography className={globalClasses.titleSectionVariant2}>
        {t('news.postgraduate.info.tab-title')}
      </Typography>
      <Box className={classes.contentContainer}>
        <Box className={classes.cardsGrid}>
          {courseFormat.map((item, index) => (
            <CourseFormatCard
              key={index}
              title={item.title}
              lines={item.lines}
            />
          ))}
        </Box>
      </Box>
      <Box className={classes.contentContainer}>
        <Typography className={globalClasses.titleSectionVariant2}>
          {t('news.postgraduate.intro.info.title')}
        </Typography>
        <Typography className={classes.paragraph}>
          O presente curso foi inspirado no programa de Residência Médica, no
          qual os alunos têm a oportunidade de participar de uma formação
          teórica na Universidade e de desempenhar atividades práticas como
          forma de consolidar os conceitos aprendidos.
        </Typography>
        <Typography className={classes.paragraph}>
          Dessa forma, uma postura profissional (dedicação integral à formação,
          produtividade e qualidade do trabalho realizado) será exigida durante
          todo o período de realização do curso.
        </Typography>
        <Typography className={classes.paragraph}>
          Os alunos selecionados irão dedicar-se integralmente ao curso, tendo
          uma rotina de trabalho de 8h diárias, de segunda a sexta, totalizando
          40h semanais.
        </Typography>
        <ul className={classes.dotList}>
          <li>
            Desenvolvimento de softwares para assegurar a privacidade de dados;
          </li>
          <li>Desenvolvimento de softwares para conformidade com a LGPD;</li>
          <li>
            Desenvolvimento de softwares para análise automática da segurança de
            bancos de dados;
          </li>
          <li>
            Desenvolvimento de softwares para análise automática da segurança de
            smartphones;
          </li>
          <li>
            Desenvolvimento de softwares para análise automática da segurança de
            redes;
          </li>
          <li>Desenvolvimento de softwares para detecção de intrusão;</li>
          <li>
            Desenvolvimento de softwares para aplicação automática de patches de
            segurança;
          </li>
          <li>
            Desenvolvimento de scripts para testes de intrusão (pentests);
          </li>
          <li>Desenvolvimento de planos de segurança cibernética;</li>
          <li>Desenvolvimento de planos de gestão de riscos;</li>
          <li>Desenvolvimento de planos de resposta a incidentes;</li>
          <li>Desenvolvimento de software seguro;</li>
          <li>Refatoração de código para mitigação de vulnerabilidades;</li>
          <li>Auditoria de sistemas informatizados e bancos de dados;</li>
          <li>Administração de ambientes computacionais;</li>
          <li>Análise de códigos maliciosos;</li>
          <li>Desenvolvimento de soluções de segurança utilizando IA;</li>
          <li>
            Elaboração de guias de melhores práticas voltados à segurança
            cibernética.
          </li>
        </ul>
      </Box>
      <Box className={classes.contentContainer}>
        <Typography variant="h3" className={globalClasses.titleSectionVariant2}>
          {t('news.postgraduate.info.obg')}
        </Typography>
        <Typography className={classes.paragraph}>
          Capacitar profissionais das áreas de Tecnologia da Informação (TI) e
          afins para que atuem na segurança cibernética de instituições públicas
          ou privadas.
        </Typography>
      </Box>
      <Box className={classes.contentContainer}>
        <Typography variant="h3" className={globalClasses.titleSectionVariant2}>
          {t('news.postgraduate.info.obe')}
        </Typography>
        <ul className={classes.dotList}>
          <li>
            Capacitar os alunos para desenvolvimento e gestão de projetos de
            segurança cibernética.
          </li>
          <li>
            Capacitar estudantes para atuar na proteção de ambientes,
            equipamentos e sistemas.
          </li>
          <li>
            Capacitar profissionais para aplicação de mecanismos de proteção.
          </li>
          <li>
            Compreender legislações relacionadas à segurança e privacidade de
            dados.
          </li>
          <li>Capacitar os alunos no desenvolvimento de software seguro.</li>
          <li>
            Desenvolver habilidades para identificação de riscos e
            vulnerabilidades.
          </li>
          <li>
            Formar profissionais com visão de negócios, processos e tecnologias.
          </li>
          <li>
            Preparar profissionais para implementação de soluções de segurança.
          </li>
          <li>
            Preparar profissionais para avaliar aspectos estratégicos da
            segurança cibernética.
          </li>
        </ul>
      </Box>
    </>
  )
}

export default Information
